import {useMemo, useRef, useState} from 'react';

import {useMeasure} from '@uidotdev/usehooks';
import {oneOfType, node, func} from 'prop-types';

import MainSidebarContext from '../contexts/MainSidebarContext';
import useReportViews from '../hooks/providers/useReportViews';

// eslint-disable-next-line complexity
const MainSidebarProvider = ({children}) => {
  const {setIsChooseViewPopperOpen} = useReportViews();
  const [isMoreModulesPopperOpen, setIsMoreModulesPopperOpen] = useState(false);
  const [moreModulesPopperAnchorEl, setMoreModulesPopperAnchorEl] = useState(null);

  const [isMoreReportsPopperOpen, setIsMoreReportsPopperOpen] = useState(false);
  const [moreReportsPopperAnchorEl, setMoreReportsPopperAnchorEl] = useState(null);
  const [reportsListContainerRef, {height: reportsListContainerHeight}] = useMeasure();

  const [sidebarReports, setSidebarReports] = useState([]);
  const [notVisibleSidebarModules, setNotVisibleSidebarModules] = useState([]);
  const [moduleCategoryExpanded, setModuleCategoryExpanded] = useState(null);
  const [isReportAndModulesMobileDrawerOpen, setIsReportAndModulesMobileDrawerOpen] = useState(false);
  const [reportModulesContainerHeight, setReportModulesContainerHeight] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [moduleSubmenuOpen, setModuleSubmenuOpen] = useState(null);
  const [modulesMenuAnchorEl, setModulesMenuAnchorEl] = useState(null);

  const moreReportsOrModulesPopperRef = useRef(null);
  const modulesListContainerRef = useRef(null);

  const shouldDisplayContactButton = reportModulesContainerHeight > 100;

  const closeAllSidebarRelatedPoppers = () => {
    setIsChooseViewPopperOpen(false);
    setIsMoreReportsPopperOpen(false);
    setIsMoreModulesPopperOpen(false);
    setModuleCategoryExpanded(null);

    setModuleSubmenuOpen(null);
  };

  const useMemoDeps = [
    isMoreModulesPopperOpen,
    setIsMoreModulesPopperOpen,
    moreModulesPopperAnchorEl,
    setMoreModulesPopperAnchorEl,
    sidebarReports,
    setSidebarReports,
    isMoreReportsPopperOpen,
    setIsMoreReportsPopperOpen,
    moreReportsPopperAnchorEl,
    setMoreReportsPopperAnchorEl,
    notVisibleSidebarModules,
    setNotVisibleSidebarModules,
    moduleCategoryExpanded,
    setModuleCategoryExpanded,
    isReportAndModulesMobileDrawerOpen,
    setIsReportAndModulesMobileDrawerOpen,
    reportModulesContainerHeight,
    setReportModulesContainerHeight,
    shouldDisplayContactButton,
    moreReportsOrModulesPopperRef,
    isDragging,
    setIsDragging,
    moduleSubmenuOpen,
    setModuleSubmenuOpen,
    modulesMenuAnchorEl,
    setModulesMenuAnchorEl,
    modulesListContainerRef,
    reportsListContainerHeight,
    reportsListContainerRef
  ];

  const value = useMemo(
    () => ({
      isMoreModulesPopperOpen,
      setIsMoreModulesPopperOpen,
      moreModulesPopperAnchorEl,
      setMoreModulesPopperAnchorEl,
      sidebarReports,
      setSidebarReports,
      isMoreReportsPopperOpen,
      setIsMoreReportsPopperOpen,
      moreReportsPopperAnchorEl,
      setMoreReportsPopperAnchorEl,
      notVisibleSidebarModules,
      setNotVisibleSidebarModules,
      moduleCategoryExpanded,
      setModuleCategoryExpanded,
      isReportAndModulesMobileDrawerOpen,
      setIsReportAndModulesMobileDrawerOpen,
      reportModulesContainerHeight,
      setReportModulesContainerHeight,
      shouldDisplayContactButton,
      moreReportsOrModulesPopperRef,
      isDragging,
      setIsDragging,
      closeAllSidebarRelatedPoppers,
      moduleSubmenuOpen,
      setModuleSubmenuOpen,
      modulesMenuAnchorEl,
      setModulesMenuAnchorEl,
      modulesListContainerRef,
      reportsListContainerHeight,
      reportsListContainerRef
    }),
    useMemoDeps
  );
  return <MainSidebarContext.Provider value={value}>{children}</MainSidebarContext.Provider>;
};

MainSidebarProvider.propTypes = {
  children: oneOfType([node, func]).isRequired
};

export default MainSidebarProvider;
